import React, { ReactElement } from 'react';
import { HStack, Text } from '@chakra-ui/react';
import { getYearCollectionString } from 'utils/getYearCollectionString';
import { EducationIcon, TimeIcon } from 'assets/icons/v2';
import { VSeparator } from '../VSeparator';
import { ReadBadge } from './ReadBadge';

type Props = {
  readingTime: number;
  relevantYears: string[];
  isRead?: boolean | null;
};

export const ArticleEntryInfoBar = ({
  readingTime,
  relevantYears,
  isRead,
}: Props): ReactElement => {
  const readingTimeText = `${readingTime} min`;
  const relevantYearsText = getYearCollectionString(relevantYears, 'Jahr');

  return (
    <HStack gap="10px" alignItems="center">
      <HStack gap="5px" alignItems="center">
        {!isRead ? (
          <>
            <TimeIcon color="icon.tertiary" glyphSize="m" />
            <Text textStyle="body.s.regular" color="text.tertiary">
              {readingTimeText}
            </Text>
          </>
        ) : (
          <ReadBadge />
        )}
      </HStack>
      <VSeparator textStyle="h4.regular" color="divider.default" />
      <HStack gap="5px" alignItems="center">
        <EducationIcon color="icon.tertiary" glyphSize="m" />
        <Text textStyle="body.s.regular" color="text.tertiary">
          {relevantYearsText}
        </Text>
      </HStack>
    </HStack>
  );
};
